import { ComplexItem } from "../components/common/ComplexList";
import { SectionItemInterface } from "../components/common/SectionList";

export const ABOUT_US = `Nasze biuro rachunkowo-ubezpieczeniowe jest znanym, profesjonalnym i dynamicznie rozwijającym się biurem obsługi małych i średnich firm. Działamy z licencją ministra finansów począwszy od marca 1999 r. Jesteśmy firmą świadczącą kompleksowe usługi na rzecz innych przedsiębiorstw w zakresie usługowego prowadzenia ksiąg, rozliczania ubezpieczeń społecznych, prowadzenia i zarządzania kadrami, doradztwa podatkowego, prawnego – gospodarczego, doradztwa inwestycyjnego, projektowania inwestycyjnego, zawierania ubezpieczeń majątkowych i komunikacyjnych i osobowych, kojarzenia klientów oraz obsługi BHP.   Pracujemy z powodzeniem już ponad 15 lat w oparciu o najnowsze środki techniki, korzystając ze sprzętu informatycznego i przekazu internetowego oraz sprawdzonych oprogramowań i sprawnych procedur.

Biuro księgowe posiada obowiązkowe ubezpieczenie zawodowe odpowiedzialności cywilnej na wykonywane usługi rachunkowe.

Współpracujemy z ekspertami, specjalistami z dziedziny ekonomii, finansów, ubezpieczeń, prawa cywilnego, gospodarczego, podatkowego i bankowego.

Nasza działalność to życzliwa, konkretna i zorientowana pomoc w problemach, z którymi spotykają się właściciele małych firm.

Naszą dewizą jest jakość obsługi, która daje gwarancję sukcesu i powodzenia nie tylko nam, ale przede wszystkim obsługiwanym przez nas klientom.`

export const THANKS_TO_US: SectionItemInterface[] = [
    {
        value: 'będziesz sprawniej zarządzał swoim czasem i firmą',
    },
    {
        value: 'rozwiniesz swoje przedsiębiorstwo we właściwym kierunku',
    },
    {
        value: 'będziesz racjonalnie zarządzał zasobami i obniżysz koszty administracyjne',
    },
    {
        value: 'będziesz miał pod ręką specjalistów i osiągniesz efektywną jakość działania',
    },
    {
        value: 'Twoja firma będzie konkurencyjna, będzie zdobywała udział w rynku',
    },
    {
        value: 'będziesz spał bezpiecznie i spokojnie nie martwiąc się jutrem',
    },
    {
        value: 'będziesz dysponował szerokim i dostępnym archiwum danych o działalności Twojej Firmy',
    },
    {
        value: 'biurokracja przestanie być dla Ciebie ciężarem',
    },
];

export const CHARACTERIZES_US = [
    'atrakcyjna lokalizacja',
    'wygodny dojazd do biura i bezpłatny parking',
    'szybka i sprawna obsługa klienta',
    'najtańsze ceny usług',
];

export const WE_WILL_DO_IT_FOR_YOU = [
    'księgowość',
    'ZUS',
    'ubezpieczenia',
    'kadry',
    'BHP',
    'biurokracja',
];

export const OFFER = [
    'rzetelne prowadzenie ksiąg rachunkowych, podatkowych',
    'solidne prowadzenie ewidencji podatkowych, ryczałtowych i innych',
    'sumienne prowadzenie ewidencji wynagrodzeń, ubezpieczeń społecznych, płac i kadr oraz bieżących zmian w tym zakresie',
    'prawidłowe sporządzanie i terminowe przekazywanie pełnej dokumentacji rozliczeniowej do ZUS, Urzędu Skarbowego ( DRA, PIT, CIT )',
    'dokonywanie rozliczeń składkowych, podatkowych, zasiłkowych, ubezpieczeń zdrowotnych oraz innych rozliczeń z dziedziny działalności gospodarczej',
    'wyręczanie Płatników i Podatników w kontaktach z ZUS-em oraz Urzędem Skarbowym, a szczególnie dotyczących składanych sprawozdań i dokumentów',
    'prowadzenie rozrachunków z kontrahentami, urzędami i ZUS-em',
    'systematyczne informowanie o bieżących zmianach związanych z problematyką ubezpieczeń, rachunkowości i podatków',
    'udzielanie instruktażu, porad z dziedziny ubezpieczeń, biznesu, inwestycji, kredytów i rynku',
];

export const FROM_YOU = [
    'przekazać kopie dokumentów rejestracyjnych oraz zgłoszeniowych dotyczących otwarcia działalności w celu założenia bazy danych płatnika, podatnika i przedsiębiorcy',
    'udzielić zgody na korzystanie z baz danych wyłącznie dla celów związanych z prowadzeniem ksiąg, rozrachunkami i płatnościami przy zachowaniu postanowień ustawy o ochronie danych osobowych',
    'dostarczać miesięcznie dokumenty księgowe',
    'dostarczać miesięcznie informacje i dane o stanie zatrudnienia, wysokości wynagrodzeń pracowników i ich obecności',
    'aktualizować dane o firmie i przekazywać informacje o istotnych zdarzeniach gospodarczych oraz wszelką korespondencję otrzymaną z ZUS-u i Urzędu Skarbowego',
    'podpisać umowę, złożyć zlecenie, przekazać pisemne upoważnienie oraz pełnomocnictwo działania',
];

export const INSURANCE: ComplexItem[] = [
    {
        text: 'do których zaliczane są : pożar, działanie dymu i sadzy, uderzenie pioruna, huragan, powódź, deszcz nawalny, grad, napór śniegu, osuwanie się ziemi, lawina, upadek drzewa lub masztu, wybuchu, upadek statku powietrznego, uderzenia pojazdu mechanicznego, zalanie, trzęsienie ziemi, przepięcia, akty terroru.',
        title: 'ognia i innych zdarzeń losowych',
    },
    {
        text: `Ubezpieczenie to zapewnia rekompensatę strat poniesionych w wyniku utraty mienia objętego umową ubezpieczenia, a także: naprawę uszkodzonych drzwi i okien, naprawę zabezpieczeń np.: zamków, systemów alarmowych, dewastacji.

Umową ubezpieczenia mogą być objęte również: koszty wymiany zamków w drzwiach zewnętrznych z powodu utraty kluczy, koszty wynajmu lokalu zastępczego, gdy w wyniku szkody ubezpieczony budynek nie nadaje się do użytkowania lub zamieszkania, koszty usługi hydraulicznej w przypadku wystąpienia awarii.
        
Ubezpieczeniem objęte są również szkody powstałe w wyniku akcji gaśniczej, wyburzania lub odgruzowywania, prowadzonych w związku z wystąpieniem zdarzeń losowych.`,
        title: 'kradzieży z włamaniem i rabunku',
    },
    {
        text: 'deliktowej i kontraktowej za szkody na osobie lub mieniu, wyrządzone w związku z posiadanym mieniem, prowadzonym przedsiębiorstwem lub czynnościami życia prywatnego. Zakres odpowiedzialności obejmuje szkody wyrządzone osobom trzecim, a powstałe między innymi w związku z: użytkowaniem lokalu lub domu, wadliwym wykonaniem robót lub usług, wprowadzeniem produktów do obrotu, amatorskim uprawianiem sportu, ustawową opieką nad dziećmi, posiadaniem zwierząt domowych',
        title: 'odpowiedzialności cywilnej',
    },
    {
        text: 'Ubezpieczenie to realizowane jest w wariantach pakietu komunikacyjnego ryzyk od odpowiedzialności cywilnej (OC) posiadaczy pojazdów mechanicznych za szkody powstałe w związku z ruchem pojazdów w kraju jak i za granicą razem z Zieloną Kartą, od autocasco (AC) użytkowników obejmujące utratę uszkodzenie i kradzież pojazdu, assistance pojazdu obejmujące natychmiastową pomoc w razie awarii, od następstw nieszczęśliwych wypadków (NNW) kierowcy i pasażerów oraz ochrony prawnej w ruchu drogowym tj. pokrycia poniesionych kosztów pomocy prawnej (OP) związanej z posiadaniem samochodu i kierowaniem nim lub z podróżą jako pasażer.',
        title: 'uszkodzenia, zniszczenia lub utraty samochodu',
    },
    {
        text: 'Ubezpieczenie to obejmuje swym zakresem świadczenie z tytułu częściowego trwałego uszczerbku na zdrowiu wskutek następstw nieszczęśliwego wypadku, śmierci, zwrot kosztów operacji i pobytu w szpitalu, ubezpieczenie assistance tj. koszty związane z udzieleniem przez COMPENSĘ natychmiastowej pomocy takiej jak koszty wizyty lekarskiej i pielęgniarskiej, dostawy leków, transportu medycznego do zakładów opieki zdrowotnej, koszty nabycia przyrządów leczniczych, środków technicznych, koszty przeszkolenia zawodowego.',
        title: 'następstw nieszczęśliwych wypadków (NNW) w życiu prywatnym',
    },
];

export const BHP_OFFER = [
    'Obsługa firm w zakresie zadań służby bhp;',
    'Szkolenia bhp dla każdej grupy zawodowej;',
    'Ocena zagrożeń zawodowych (ryzyko zawodowe);',
    'Doradztwo w zakresie obowiązujących zasad i przepisów bhp;',
    'Udział w dochodzeniach powypadkowych oraz opracowywanie stosownej dokumentacji.',
];

export const TRAINING_BHP: ComplexItem[] = [
    {
        text: 'odbywają się przed dopuszczeniem do wykonywania pracy, wszyscy nowo zatrudnieni pracownicy, studenci odbywający u pracodawcy praktykę studencką oraz uczniowie szkół zawodowych zatrudnieni w celu praktycznej nauki zawodu.',
        title: 'Szkolenia wstępne:',
    },
    {
        text: `1. Osób będących pracodawcami oraz kierujących pracownikami, w szczególności kierowników, mistrzów i brygadzistów;
2. Pracowników zatrudnionych na stanowiskach robotniczych;
3. Pracowników inżynieryjno-techniczni, w tym projektantów, konstruktorów maszyn i innych urządzeń technicznych, technologów i organizatorów produkcji;
4. Pracowników administracyjno-biurowych
        
Szkolenia prowadzone są zgodnie z Rozporządzeniem Ministra Gospodarki i Pracy z dnia 27 lipca 2004 r. w sprawie szkolenia w dziedzinie bezpieczeństwa i higieny pracy. (Dz.U. nr 180, poz. 1860) z późniejszymi zmianami.
Cechuje nas indywidualne podejście do każdej szkolonej przez nas grupy, uwzględniamy opinie i potrzeby naszych Klientów.

Szkolenia mają formę kursów, seminariów, przeprowadzane są z użyciem filmów, skryptów, prezentacji multimedialnych.

Szkolenia odbywają się zarówno w siedzibie naszej firmy jak i u klienta.

Każde szkolenie okresowe kończy się egzaminem oraz wydaniem stosownego, zgodnego z wymaganiami zaświadczenia o ukończeniu kursu.`,
        title: 'Szkolenia okresowe dla:',
    },
    {
        text: 'wykonywane są zgodnie z zapotrzebowaniem określenia oceny zagrożeń występujących na poszczególnych stanowiskach pracy w przedsiębiorstwie z uwzględnieniem czynników niebezpiecznych, szkodliwych i uciążliwych dla zdrowia i życia pracownika.',
        title: 'Elaboraty oceny ryzyka zawodowego:',
    },
    {
        text: 'obejmuje sporządzenie kompletnej dokumentacji urzędowej dotyczącej ustalenia okoliczności i przyczyn wypadku przy pracy jaką wykonać musi zespół powypadkowy celem określenia prawa pracownika poszkodowanego do świadczeń z tytułu wypadku i złożenia stosownej dokumentacji do ZUS, GUS i Państwowej Inspekcji Pracy.',
        title: 'Opracowania dokumentacji powypadkowej:',
    },
];

export const OPENING_HOURS = `poniedziałek: 9:00 - 15:00
wtorek: 9:00 - 15:00, 17:30 - 19:30
środa: 9:00 - 15:00
czwartek: 9:00 - 15:00, 17:30 - 19:30
piątek: 9:00 - 15:00`